const FromArr = [
  {
    title: "经销商名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 150,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  
  {
    title: "产品线：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 20,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
  {
    title: "采购代理：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 70,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "下级经销商：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 150,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 20,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "医院名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 195,
    height: 32,
    disabled: false,
    marginLeft: 5,
    marginTop: 20,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "是否有终端医院发票：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 5,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [
      {
        key: "1",
        value: "是",
      },
      {
        key: "2",
        value: "否",
      },
    ]
  },
  {
    title: "审核日期：",
    StartTime: '',
    EndTime: '',
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    widthLeft: 150,
    widthRight: 150,
    disabled: false,
    marginLeft: 30,
    marginTop: 24,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "创建日期：",
    StartTime: '',
    EndTime: '',
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    widthLeft: 150,
    widthRight: 150,
    disabled: false,
    marginLeft: 65,
    marginTop: 24,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
];
export default FromArr;
